import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export const BlockSectionContent = ({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<"div">) => (
  <div
    className={classNames(
      "wb-flex wb-flex-col",
      "wb-px-5 wb-py-12 md:wb-px-14 md:wb-py-28",
      "wb-gap-10 md:wb-gap-20",
      className,
    )}
    data-block-content
    {...rest}
  >
    {children}
  </div>
);

BlockSectionContent.displayName = "BlockSectionContent";
